(function () {
    'use strict';
    angular.module('AngularAdmin')

        .directive('pdOrderCalendar', ['$rootScope', function ($rootScope) {
            return {
                restrict: "E",
                templateUrl: '/static/partials/order_calendar.html',
                controller: "OrdersCalendarCtrl",
                replace: true,
                scope: true,
                require: 'pdCalendar',
                link: function ($scope, $element, $attr) {

                    $scope.isHoveredOrderBundle = function (order_date) {
                        return order_date && order_date.order.id && $scope.hoveredOrderBundle == order_date.order.id;
                    };

                    $scope.setHoveredOrderBundle = function (order_date) {
                        $scope.hoveredOrderBundle = order_date && order_date.order.id;
                    };

                    $scope.hoveredOrderBundle = null;

                    $scope.note_icons = [
                        {name: "user", class: "fa fa-user"},
                        {name: "wrench", class: "glyphicon glyphicon-wrench"},
                        {name: "ban-circle", class: "glyphicon glyphicon-ban-circle"},
                        {name: "exclamation-triangle", class: "fa fa-exclamation-triangle"},
                        {name: "pushpin", class: "glyphicon glyphicon-pushpin"},
                        {name: "sticky-note", class: "fa fa-sticky-note"}
                    ];

                    $scope.getIconClass = function (icon_name) {
                        return Array.findObject($scope.note_icons, "name", icon_name).class;
                    };

                }
            };
        }])

        .directive('pdOrderCalendarDayCell', [function () {
            return {
                restrict: "A",
                templateUrl: '/static/partials/order_calendar_day_cell.html',

                link: function ($scope, $element, $attr) {
                    //
                    // Scope Functions
                    //
                    $scope.isNegative = function (number) {
                        return number <= 0;
                    };

                    $scope.isInCell = function (order_date) {
                        return !order_date.nightshift == !!$scope.isTopCell;
                    };

                    $scope.hasMultipleOrders = function (day, shift) {

                        var order_dates = [];

                        angular.forEach(day.outputs, function (output) {
                            var output_order_dates = output.order_dates.filter(function (item) {
                                switch (shift) {
                                    case "dayshift":
                                        return !item.nightshift;
                                    case "nightshift":
                                        return item.nightshift;
                                    default:
                                        return true;
                                }
                            });

                            order_dates = order_dates.concat(output_order_dates);
                        });

                        return order_dates.length > 1;
                    };

                    $scope.isPlantClosed = function (day) {

                        if (angular.isUndefined(day.notes)) return;

                        var isClosed = day.notes.some(function (note) {
                            return note.type == "plant_closure";
                        });

                        return isClosed;
                    };

                    //
                    // Init
                    //
                    $scope.isTopCell = $attr.istopcell == 'true';
                }
            };
        }])

        .directive('pdOrderCalendarDayPopover', [function () {
            return {
                restrict: "A",
                templateUrl: '/static/partials/order_calendar_popover.html',

                link: function ($scope, $element, $attr) {

                    $scope.tab = $scope.tab || "orders";

                    $scope.setTab = function (tab) {
                        $scope.tab = tab;
                    };

                }
            };
        }]);


})();
